/** Must match Roller.Core.Domain.Enums.PaymentTypes */
export enum EPaymentTypes {
  none = 0,
  CreditCard = 1,
  'Cards' = CreditCard,

  CreditCardPreAuth = 2,
  'Credit Card Auth' = CreditCardPreAuth,

  Cash = 3,
  'GENERIC.CASH' = Cash,

  Eftpos = 4,

  PayPal = 5,
  'GENERIC.PAYPAL' = PayPal,

  Other = 6,

  Giftcard = 7,
  'Gift card' = Giftcard,

  BankTransfer = 8,
  'Bank transfer' = BankTransfer,

  BPay = 9,

  Cheque = 10,

  Prepaid = 11,

  Points = 12,

  Wallet = 13,

  Groupon = 14,
  'Voucher' = Groupon
}
